import React from "react";
import {
    EmailShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    RedditShareButton,
    TelegramShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    FacebookIcon,
    RedditIcon,
    TelegramIcon,
    LinkedinIcon,
    WhatsappIcon,
    EmailIcon,
    TwitterIcon
} from "react-share";


export default function AppFooter(props) {
    return(
    <div className="app-footer">
        <TwitterShareButton
            url={window.location.href}
            title={`${props.shareText} by @NikitBhandari` }
            className="social-icon"
        >
            <TwitterIcon size={45} round />
        </TwitterShareButton>
        <LinkedinShareButton url={window.location.href} className="social-icon">
            <LinkedinIcon size={45} round />
        </LinkedinShareButton>
        <RedditShareButton
            url={window.location.href}
            title={props.shareText}
            windowWidth={660}
            windowHeight={460}
            className="social-icon"

        >
            <RedditIcon size={45} round />
        </RedditShareButton>
        <FacebookShareButton
            url={window.location.href}
            quote={props.shareText}
            className="social-icon"
        >
            <FacebookIcon size={45} round />
        </FacebookShareButton>
        <WhatsappShareButton
            url={window.location.href}
            title={props.shareText}
            separator=" "
            className="social-icon"
        >
            <WhatsappIcon size={45} round />
        </WhatsappShareButton>

        <TelegramShareButton
            url={window.location.href}
            title={props.shareText}
            className="social-icon"
        >
            <TelegramIcon size={45} round />
        </TelegramShareButton>
        <EmailShareButton
            url={window.location.href}
            subject="App Release Insights"
            body={props.shareText}
            className="social-icon"
        >
            <EmailIcon size={45} round />
        </EmailShareButton>
    </div>
    )
};


